import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import classNames from 'classnames';
import { ArmyListUnitOptionAction } from '@Redux/actions';
import { OptionInfoView, OptionView } from '@Selectors/builder/myArmyList/make/unit/edit/OptionView';
import { TYPES } from '@Types';
import { container } from '@Container';
import { Tooltip } from 'react-tooltip';
import parser from 'bbcode-to-react';
import Repeater from '@Utils/Repeater';
import { UnitOptionGroupView } from '@Selectors/builder/myArmyList/make/view/unit-option-group.view';

interface IOptionComponentProps {
  allOptions: OptionView[],
  unitOptionGroup: UnitOptionGroupView,
  option: OptionView,
}

const OptionComponent: React.FC<OptionComponentProps> = (
  {
    allOptions,
    unitOptionGroup,
    option,
    onCheck,
    onQuantityChange
  }
) => {
  if (!option.status.isVisible || option.status.isHidden) {
    return (<div />);
  }

  return (
    <div
      className={classNames('option', 'profundity-' + option.profondeur, { 'read-only': !option.status.canSelect && option.points != null })}>
      {option.points != null && option.points.current > 0 && !option.points.isLimit &&
        <em>{option.points.current} pts</em>}
      <label>
        {option.points != null &&
          !option.points.isLimit &&
          option.status.canSelect && <input type="checkbox"
                                            checked={option.status.isChecked}
                                            disabled={!option.status.canSelect}
                                            onChange={(e) => onCheck(allOptions, unitOptionGroup, option, e.target.checked)}
                                            className="ms-1 me-1" />}
        {option.name}
        {option.multiple?.max != null &&
          option.multiple?.noLimit == false && <small>({option.multiple.current}/{option.multiple.max})</small>}
        {option.isMultiple &&
          option.status.isChecked &&
          option.multiple && (option.multiple!.delta! > 1 || option.multiple.noLimit) &&
          <input type="number"
                 value={option.quantity ?? undefined}
                 step="1"
                 min="1"
                 max={option.multiple.noLimit ? undefined : option.multiple.delta!}
                 onChange={(e) => onQuantityChange(unitOptionGroup, option, option.multiple!.min, e.target.value, option.multiple!.max!)}
                 className="ms-1" />}
        {option.points != null && option.points.current > 0 && option.points.isLimit &&
          <em>up to {option.points.current} pts</em>}
        <Repeater data={option.infos} indexPrefix={'info'}>
          {
            (info: OptionInfoView) => (
              <>

                <i className="fas fa-circle-info m-1" data-tooltip-id={`option-info-${info.id}`} data-tooltip-place="top"
                   data-tooltip-variant="light"></i>
                <Tooltip id={`option-info-${info.id}`}
                         className="tooltip-content">
                  <div>
                    <h3>{info.name}</h3>
                    <p>{parser.toReact(info.description)}</p>
                  </div>
                </Tooltip>
              </>
            )
          }
        </Repeater>
      </label>

    </div>
  );
};

const mapStateToProps = (state: AppState, owsProps: IOptionComponentProps) => ({
  allOptions: owsProps.allOptions,
  unitOptionGroup: owsProps.unitOptionGroup,
  option: owsProps.option
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const action = container.get<ArmyListUnitOptionAction>(TYPES.Actions.ArmyListUnitOptionAction);
  return {
    onCheck: (allOptions: OptionView[], unitOptionGroup: UnitOptionGroupView, item: OptionView, isChecked: boolean) =>
      dispatch(action.actionArmyListUnitOptionSelect(allOptions, unitOptionGroup, unitOptionGroup.options, item, isChecked)),
    onQuantityChange: (unitOptionGroup: UnitOptionGroupView, item: OptionView, min: number, input: string, max: number) =>
      dispatch(action.actionArmyListUnitOptionQuantityChange(unitOptionGroup, unitOptionGroup.options, item, input, min, max))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OptionComponent);

type OptionComponentProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
